import csvToJson from "../csvToJson";

/**
 * Supplier to start to use the algorithm
 * @param algorithm csv file with the questions and answers algorithm for the Anfaelle
 * @returns {{}} object representation the first row from the algorithm
 */
function firstRowSupplier(algorithm) {
    console.log({
        "msg": "Supplying first row for anfaelleAlgorithm",
        "component": "anfaelle"
    })
    // TODO introduce caching instead of parsing the algorithm every single time
    return csvToJson(algorithm)[0]
}

/**
 * Function used to find the next rows for the given actual row
 * @param actualRow object representation of a row from the algorithm
 * @param algorithm csv file with the questions and answers algorithm for the Anfaelle
 * @returns {[]} array of objects containing the possible next rows of the algorithm
 */
function providePossibleNextRows(actualRow, algorithm) {
    let IDX = actualRow["IDX"]
    if (IDX === undefined || IDX === "") {
        console.log({"msg": "the given row did not have an IDX", "givenRow": actualRow, "component": "anfaelle"})
        return undefined
    } else {
        const possibleNextRows = csvToJson(algorithm).filter(row => row["Frage_ID"] === IDX)
        console.log(
            {
                "msg": "providing nextRow",
                "component": "anfaelle",
                "givenRow": actualRow,
                "possibleNextRows": possibleNextRows
            })

        return possibleNextRows
    }
}

export default {firstRowSupplier: firstRowSupplier, providePossibleNextRows: providePossibleNextRows}
